import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import type { PresenceStatus } from '@/types/realtime';

type PresenceState = {
    users: Record<
        string,
        {
            status: PresenceStatus;
            lastSeenAt?: number;
        }
    >;
    update: (userId: string, data: { status: PresenceStatus; lastSeenAt?: number }) => void;
};

export const usePresenceStore = create<PresenceState>()(
    immer((set) => ({
        users: {},
        update: (userId, data) =>
            set((state) => {
                state.users[userId] = data;
            }),
    })),
);
